import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {VkService} from './vk.service';
import {TabsetComponent} from 'ngx-bootstrap/tabs';
import {WebsocketService} from '../../services/websocket';
import {environment} from '../../../environments/environment';
import {AllService} from '../../services/all.service';
import {Subject, Subscription, takeUntil} from 'rxjs';
import {CarouselComponent, OwlOptions} from 'ngx-owl-carousel-o';
import {InterfaceService} from '../../services/interface.service';
import {filter} from 'rxjs/operators';
import {DcService} from '../../services/dc.service';


@Component({
  selector: 'app-page-vk',
  templateUrl: './page-vk.component.html',
  styleUrls: ['./page-vk.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageVkComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  environment = environment;
  @ViewChild('staticTabs', {static: false}) staticTabs: TabsetComponent;
  @ViewChild('sideBar') sideBar: ElementRef;
  @ViewChild('carousel', {static: true}) carousel: CarouselComponent;
  activeTab = 0;
  customOptions: OwlOptions = {
    autoWidth: false,
    autoHeight: false,
    responsiveRefreshRate: 500,
    loop: false,
    rewind: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    dotsData: false,
    items: 1,
    responsive: {
      0: {
        items: 1
      }
    },
    navSpeed: 700,
    navText: ['', ''],
    nav: false
  };
  blockScroll = false;
  blockPan = false;
  p0 = [0, 0];

  constructor(
    private dcService: DcService,
    private cd: ChangeDetectorRef,
    public allService: AllService,
    public wsService: WebsocketService,
    public vkService: VkService,
    public interfaceService: InterfaceService
  ) {
  }

  ngOnInit(): void {
    this.wsService.status.subscribe(() => {
      this.cd.detectChanges();
    });
    this.dcService.detectChanges$.pipe(
      takeUntil(this.destroy$), filter(v => v === 'page-vk')
    ).subscribe((component) => {
      this.detectChanges();
    });
    this.allService.login$.pipe(takeUntil(this.destroy$)).subscribe((component) => {
      this.cd.detectChanges();
    });
  }

  touchstart(e) {
    this.p0 = [e.touches[0].screenX, e.touches[0].screenY];
    this.blockScroll = false;
    this.blockPan = false;
  }

  selectTab(tabId: number) {
    this.activeTab = tabId;
    this.staticTabs.tabs[tabId].active = true;
    // this.carousel.to(this.carousel.slidesData[tabId].id);
  }

  detectChanges() {
    setTimeout(() => {
      this.cd.detectChanges();
    }, 250);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
